import { css } from 'styled-components'
import { fluidRange, math } from 'polished'
import { pxToRem, modularScale } from 'utils/helpers'
import { COLORS } from 'config/constants'

export const getTransition = (property) =>
  `${property} 0.2s cubic-bezier(0.77,0.2,0.05,1.0)`

export const fontStack = `"Gotham", sans-serif;`

export const colors = {
  // text: COLORS.SHADOWED_STEEL,
  brandCta: COLORS.RED_ORANGE_JUICE,
  text: COLORS.LUXURY,
  secondaryText: COLORS.CODEX_GREY,
  heading: COLORS.DARK_SAPHIRE,
  lightBg: COLORS.ZHEN_ZHU_BAI_PEARL,
  white: COLORS.WHITE,
}

export const space = {
  xxs: pxToRem(2),
  xs: pxToRem(4),
  s: pxToRem(8),
  m: pxToRem(16),
  l: pxToRem(32),
  xl: pxToRem(64),
  xxl: pxToRem(128),
  xxxl: pxToRem(256),
  xxxxl: pxToRem(400),
}

export const fontSizes = {
  xs: modularScale(-2),
  s: modularScale(-1),
  m: modularScale(0),
  l: modularScale(1),
  xl: modularScale(2),
  xxl: modularScale(3),
  h3: modularScale(4),
  h2: modularScale(5),
  h1: modularScale(6),
}

export const fontWeights = {
  normal: 400,
  semi_bold: 500,
  bold: 700,
}

export const radius = {
  m: '4px',
  l: '10px',
  pill: '9999px',
}

export const border = `1px solid ${COLORS.BUTTERSCOTCH}`

export const globalStyles = css`
  html,
  body {
    min-width: 320px;
  }
  html {
    ${fluidRange({
      prop: 'font-size',
      fromSize: '14px',
      toSize: '18px',
    })}
  }
  body {
    font-family: ${fontStack};
    color: ${colors.text};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: auto;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 0.5em 0;
  }
  h1,
  h2,
  h3 {
    line-height: 1.3;
  }
  h4,
  h5,
  h6 {
    line-height: 1.5;
  }

  p {
    margin: 0;
  }
  input,
  input::placeholder,
  textarea,
  button {
    font-family: inherit;
    font-size: ${fontSizes.m};
  }
  button {
    border: none;
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
  ::selection {
    color: ${COLORS.WHITE};
    background: ${COLORS.ARAGON_GREEN};
  }
`

// mobile is not included, as it's the base - see mobile-first design
const devices = {
  mobile: '0',
  tablet: '768px',
  desktop: '1024px',
}

export const breakpoints = [devices.mobile, devices.tablet, devices.desktop]

// this enables the better - object - form of using media queries within styled-system props while still leaving the current array notation intact until we migrate it
/* eslint-disable prefer-destructuring */
breakpoints.mobile = breakpoints[0]
breakpoints.tablet = breakpoints[1]
breakpoints.desktop = breakpoints[2]
/* eslint-enable prefer-destructuring */

const mediaQuery = ({ mobileFirst = true }) =>
  Object.entries(devices).reduce((deviceMediaQueries, [label, breakpoint]) => {
    return {
      ...deviceMediaQueries,
      [label]: (...args) => css`
        @media screen and (${mobileFirst ? 'min-width' : 'max-width'}: ${math(
        `${breakpoint} - 0.1px`
      )}) {
          ${css(...args)}
        }
      `,
    }
  }, {})

// mq is for usage within `styled` function
export const mq = {
  to: mediaQuery({ mobileFirst: false }),
  from: mediaQuery({ mobileFirst: true }),
}

export const springConfig = {
  config: {
    mass: 1,
    tension: 800,
    friction: 80,
    velocity: 5,
  },
}

export const theme = {
  colors,
  space,
  fontSizes,
  fontWeights,
  breakpoints,
}
